import { defineAsyncComponent } from "vue";
import AuthLogin from "@two-ui/views/AuthLogin.vue";
import { createRouter, createWebHistory } from "vue-router";
import LoadingSpinner from "@two-ui/components/LoadingSpinner.vue";

export function initProductsRoutes() {
  return [
    {
      path: "/",
      redirect: "/runa-network",
    },
    {
      path: "/login",
      component: AuthLogin,
      name: "auth-login",
      meta: { preAuth: true },
    },
    {
      path: "/runa-network",
      name: "product-catalog",
      component: async () =>
        defineAsyncComponent({
          loader: () => import("./views/BasePage.vue"),
          loadingComponent: LoadingSpinner,
        }),
      children: subRoutes,
      meta: { requiresCustomerId: true },
    },
  ];
}

export const subRoutes = [
  {
    path: "",
    name: "runa-network-home",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/Home.vue"),
        loadingComponent: LoadingSpinner,
      }),
  },
  {
    path: "product-details/:productId",
    name: "product-details",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/ProductDetails.vue"),
        loadingComponent: LoadingSpinner,
      }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (from.meta.scrollTopOnLeave || to.meta.scrollTopOnEnter)
      return {
        top: 0,
        left: 0,
      };
    else if (savedPosition) return savedPosition;
  },
  routes: initProductsRoutes(),
});

export default router;
